var $43a1e3ab6b580bac$exports = {};
$43a1e3ab6b580bac$exports = {
    "info": `Informacija`,
    "negative": `Klaida`,
    "notice": `\u{12E}sp\u{117}jimas`,
    "positive": `S\u{117}kmingai`
};


export {$43a1e3ab6b580bac$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
